import React from 'react'

const Instructor = () => {
  return (
    <div>
      <h1 className='text-3xl text-richblack-5 font-semibold'>Instructor Dashboard</h1>
      <p className='text-lg text-richblack-300 mt-2'>Manage your courses and students from here.</p>
      <div className='mt-10'>
        
      </div>
    </div>
  )
}

export default Instructor